import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {authGuard, authGuardMatch, loggedInGuard} from '@innobile/authmodule';
import {PasswordResetComponent} from './password-reset/password-reset.component';

const routes: Routes = [{
  path: 'login',
  canActivate: [loggedInGuard],
  component: LoginComponent
}, {
  path: 'reset-password',
  component: PasswordResetComponent
}, {
  path: '',
  canMatch: [authGuardMatch],
  canActivate: [authGuard],
  data: {breadcrumb: null},
  loadChildren: () => import('./main/main.module').then(m => m.MainModule)
}, {
  path: '**',
  redirectTo: ''
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
